import { eUSAState } from '../../enums/states';

export interface IAddressResponse {
  id?: string;
  streetAddress: string;
  unit?: string | null;
  city: string;
  stateAbbreviation: string;
  zipCode: string;
  countyFips?: string;
  countyName?: string;
}

export interface IAddressData {
  streetAddress: string;
  unit: string;
  city: string;
  stateAbbreviation: eUSAState;
  zipCode: string;
  countyName: string;
  countyFips: string;
}

export const createDefaultAddressData = (): IAddressData => ({
  streetAddress: '',
  unit: '',
  city: '',
  stateAbbreviation: eUSAState.NY,
  zipCode: '',
  countyName: '',
  countyFips: '',
});

export const addressDataToString = ({
  streetAddress,
  unit,
  city,
  stateAbbreviation,
  zipCode,
}: Pick<IAddressData, 'streetAddress' | 'city' | 'stateAbbreviation' | 'unit' | 'zipCode'>) =>
  `${streetAddress}${unit ? ` ${unit}` : ''} ${city}, ${stateAbbreviation} ${zipCode}`;
